document.addEventListener('alpine:init', () => {
  const stored = localStorage.getItem('privacyMode');
  const initialValue = stored !== null ? JSON.parse(stored) : false;
    
  Alpine.store('privacyMode', {
    enabled: initialValue
  });
  
  Alpine.data('privacyToggle', () => ({
    init() {
      this.$watch('Alpine.store("privacyMode").enabled', (value) => {
        localStorage.setItem('privacyMode', JSON.stringify(value));
      });
    }
  }));
}); 